import { styled } from "@mui/material";

export const Status = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "0.5rem",
  padding: 0,
  margin: "0.5rem 0 0 0",
}));

export const SquareMenu = styled("div")(({ color }: { color: string }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  width: "1rem",
  height: "1rem",
  borderRadius: "1px",
  background: color,
}));

export const ContainerSquare = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "1.5rem",
}));
